// Название из описания техпроцесса ({ ru, en, … }) на языке интерфейса.

import i18n from "i18next";

import type { LocaleName } from "./types";

export function localized(name: LocaleName | undefined, fallback = ""): string {
  if (!name) return fallback;
  const lang = (i18n.language || "ru").split("-")[0] ?? "ru";
  return name[lang] ?? name.ru ?? Object.values(name)[0] ?? fallback;
}
